import {Field} from 'formik';
import {Stack} from '@mantine/core';
import {FormikSelect, FormikTextInput} from '@flexinet/ui-components';

const stateOptions = [
    {value: '', label: 'All States'},
    {value: 'OPEN', label: 'Open'},
    {value: 'CLOSED', label: 'Closed'},
];

// FNP-534: only backend-supported filters (MeteringRecordsFilterInput = state,
// customerId, meterId). meterId is omitted from the UI for now; meterCode + date
// range are deferred to FNP-538 (need a GSI).
export const FilterFormComponent = () => {
    return (
        <Stack gap='md' my='md'>
            <Field
                name='state'
                label='State'
                data={stateOptions}
                component={FormikSelect}
            />
            <Field
                name='customerId'
                label='Customer ID'
                component={FormikTextInput}
            />
        </Stack>
    );
};
